import GallerySlider from "components/GallerySlider/GallerySlider";
import { getCommissionSetting } from "functions/redux/country/action";
import { currency, showAlert } from "functions/redux/general/action";
import { dataDeleteService, getGuideOpenTrip, openTripCheck, resetForm, submitOpenTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import moment from "moment";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import NcModal from "shared/NcModal/NcModal";
import { finalPriceCalc } from "../PrivateTrip/stepper/PrivateStepThree";
import OpenStepFour from "./stepper/OpenStepFour";
import OpenStepOne from "./stepper/OpenStepOne";
import OpenStepThree from "./stepper/OpenStepThree";
import OpenStepTwo from "./stepper/OpenStepTwo";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory, useLocation } from "react-router-dom";
import { lstat } from "fs";

const PageOpenAdd = () => {
    const location = useLocation();
    const search = location.search;
    const idEdit = new URLSearchParams(search).get("id");
    const [step, setStep] = useState(1);
    const { listing, general, countriesReducer } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const { commissionSetting } = countriesReducer;
    const [showConfirmation, setShowConfirmation] = useState(false);
    const history = useHistory();
    const [isTerm, setIsTerm] = useState(false);
    const [isCancel, setisCancel] = useState(false);
    useEffect(() => {
        if (countriesReducer.commissionSetting == null) {
            dispatch(getCommissionSetting());
        }
        if (idEdit != null) {
            dispatch(openTripCheck(idEdit));
        }
        dispatch(dataDeleteService(null));
    }, []);


    const renderStep = (param: any) => {
        switch (param) {
            case 2:
                return <OpenStepTwo form={listing.addOpenTrip} />;
            case 3:
                return <OpenStepThree form={listing.addOpenTrip} />;
            case 4:
                return <OpenStepFour form={listing.addOpenTrip} />;
            default:
                return <OpenStepOne form={listing.addOpenTrip} />;
        }
    }
    const continueBtn = () => {
        if (loading === false) {
            if (step === 3 && listing.addOpenTrip.productImages === undefined) {
                toast("Tambahkan minimal satu gambar");
            } else
                if (step === 4) {
                    setShowConfirmation(true);
                    // submitProduct();
                } else {
                    setStep(step + 1);
                }
        }
    }

    const goBack = () => {
        setStep(step - 1);
    }
    const formAdd = () => {
        return (<div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-70 px-4 py-4 sm:p-4 xl:p-4">
            <div
                className={`max-w-3xl`}
            >
                <ToastContainer position="bottom-right" />

                <div className="space-y-11">

                    <div className="listingSection__wrap ">
                        {idEdit != null && listing.addOpenTrip == null ? <>
                            <Loader
                                type="Circles"
                                color="#d34d29"
                                height={25}
                                width={25}
                            />
                        </> : renderStep(step)}
                    </div>

                    <div className="flex justify-end space-x-5">
                        {step > 1 ? <ButtonSecondary onClick={goBack} >{t('go_back')}</ButtonSecondary> : <></>}
                        <ButtonPrimary onClick={continueBtn}>
                            {
                                loading ?
                                    <Loader
                                        type="Circles"
                                        color="#ffffff"
                                        height={25}
                                        width={25}
                                    /> : (step < 4 ? t('continue') : t('submit'))
                            }

                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        </div >
        );
    }

    const overview = () => {
        return (
            <div className="border-b border-neutral-200 dark:border-neutral-700">
                <div
                    className={`w-full flex flex-col group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow `}
                >
                    <div className="relative w-full h-80 flex-1">
                        {/* <GallerySlider galleryImgs={listing.addOpenTrip?.productImages ?? [
                            "https://images.pexels.com/photos/1268871/pexels-photo-1268871.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
                            "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        ]} /> */}
                        {/* <GallerySlider galleryImgs={[
                            "https://images.pexels.com/photos/1268871/pexels-photo-1268871.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
                            "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        ]} /> */}
                    </div>
                    <div className="mt-4 p-4 space-y-4">
                        <div className="space-y-2 flex flex-col">
                            <span className="text-sm text-neutral-500 dark:text-neutral-400">
                                {listing.addOpenTrip?.startTripDate ? moment(listing.addOpenTrip.startTripDate).format('MMMM Do YYYY') : ""} - {listing.addOpenTrip?.endTripDate ? moment(listing.addOpenTrip.endTripDate).format('MMMM Do YYYY') : ""}
                            </span>
                            <div className="flex items-center ">
                                <h2
                                    className={` font-medium capitalize text-lg `}
                                >
                                    <span className="line-clamp-1">{listing.addOpenTrip?.title ?? "-"}</span>
                                </h2>
                            </div>
                            <div className="flex  text-neutral-500 dark:text-neutral-400 text-sm space-x-2 !mb-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                </svg>
                                <span className="">{listing.addOpenTrip?.meetingAddress ?? 'Meeting address'}</span>
                            </div>

                            <span className=" text-neutral-500 dark:text-neutral-400 text-sm italic">{listing.addOpenTrip?.highlight ?? "---"}</span>
                            <span className="!whitespace-pre-wrap text-neutral-500 dark:text-neutral-400 text-sm">{listing.addOpenTrip?.description ?? "-------"}</span>



                            {listing.addOpenTrip?.additionalContact ?
                                <span className="text-neutral-500 dark:text-neutral-400 text-sm space-x-2">{t('add_contact')} : {listing.addOpenTrip?.additionalContact}</span>
                                : <></>}
                        </div>
                        <div className=" border-b border-neutral-100 dark:border-neutral-800"></div>
                        <div className="flex justify-between items-center">
                            <span className="text-base font-semibold">
                                {/* {currency(listing.addOpenTrip?.totalPrice ?
                                    finalPriceCalc(
                                        listing?.addOpenTrip?.totalPrice,
                                        commissionSetting?.guideFee,
                                        commissionSetting?.isGuideFeePercent
                                    ) : 0)} */}
                                {currency(listing.addOpenTrip?.totalPrice ?
                                    listing.addOpenTrip?.totalPrice
                                    : 0)}
                                <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                                    / pax
                                </span>
                            </span>
                            <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
                                <span className="">{t('guest')} : {listing.addOpenTrip?.minGuest} - {listing.addOpenTrip?.maxGuest}</span>

                            </div>

                        </div>
                    </div>
                </div>
            </div>);
    }

    const submitProduct = async () => {
        setLoading(true);
        var result = await submitOpenTrip(listing.addOpenTrip);
        if (result) {
            dispatch(resetForm());
            dispatch(getGuideOpenTrip());
            history.replace('/profile');
            dispatch(showAlert(t('new_trip_submitted'), "Success", true));
        } else {
            setLoading(false);
        }
    }

    return (
        <div
            className="relative flex flex-col lg:flex-row items-center py-14"
        >
            <NcModal
                isOpenProp={showConfirmation}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => {
                    return (
                        <div className="max-w-md">
                            <p className="text-center font-regular ">
                                Your price will be adjusted with commission fee, if you are not
                                aware of that tap the button on completion section to see
                                detail. You want to continue to submit?
                            </p>
                            <hr className="my-4" />
                            <div className="flex flex-col" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                    <input
                                        style={{ position: 'relative', top: 5 }}
                                        className="mr-2"
                                        name="isGoing"
                                        type="checkbox"
                                        checked={isTerm}
                                        onChange={() => setIsTerm(!isTerm)} />
                                    <div className="text-left">I have read and agree to the <a href="/term-and-condition" target={"_blank"} className="text-primary-6000">Terms and Conditions</a> of Guidesantai</div>
                                </label>
                                <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                    <input
                                        style={{ position: 'relative', top: 5 }}
                                        className="mr-2"
                                        name="isGoing"
                                        type="checkbox"
                                        checked={isCancel}
                                        onChange={() => setisCancel(!isCancel)} />
                                    <div className="text-left">I have read and agree to the <a href="/cancelation-policy" target={"_blank"} className="text-primary-6000">Cancelation Policy</a> of Guidesantai</div>
                                </label>
                            </div>
                            <div className="flex justify-end space-x-5 mt-8">
                                <ButtonSecondary onClick={() => setShowConfirmation(false)} >{t('go_back')}</ButtonSecondary>
                                <ButtonPrimary disabled={isCancel && isTerm ? false : true} onClick={() => {
                                    setShowConfirmation(false);
                                    submitProduct();
                                }}
                                >{t('continue')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )
                }}
                hideCloseBtn={true}
                // contentExtraClass="w-1/4"
                modalTitle={t('confirmation')}
            />

            <main className="container mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="flex-grow lg:order-first order-last">
                    {formAdd()}
                </div>
                <div className="max-w-2xl flex-shrink-0 mb-10 lg:mb-0 lg:pl-16 lg:w-2/5 lg:order-last order-first">
                    {overview()}
                </div>
            </main>
            <NcModal
                isOpenProp={general.alert.show}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => { return general.alert.content; }}
                onCloseModal={() => {
                    dispatch(showAlert("", "", false))
                }}
                modalTitle={general.alert.title}
            />
        </div>
    );
}

export default PageOpenAdd